export enum ROLE_KEYS {
    admin = 'ROLE_ADMIN',
    expert = 'ROLE_EXPERT',
    president = 'ROLE_PRESIDENT',
    datavis = 'ROLE_DATAVIS',
    superadmin = 'ROLE_SUPERADMIN',
    partner = 'ROLE_PARTNER',
    patient = 'ROLE_PATIENT',
    associate = 'ROLE_ASSOCIATE',
}
